import { Component, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OnAppModuleInit } from 'src/app/app.component';
import { Authorization, AuthService } from 'src/app/shared/services/api/auth.service';
import { UtilsService } from 'src/app/shared/services/api/utils.service';
import { BetweenPagesService } from 'src/app/shared/services/between-pages.service';
import { onHeaderLoading } from './header-loading.events';
import { LoadingService } from 'src/app/shared/services/api/loading.service';
import { DialogComponent } from '../dialog/dialog.component';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  isLoading: boolean = false;

  authorization: Authorization;

  appModule: any;

  appModules: Record <string, any> = {

    "MODULE_ALERTS_VISUALIZATION": {
      logo: "/assets/img/header/iconModConsultaEvisualizacao.svg",
      title: "Módulo de Consulta e Visualização"
    },

  };

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public authService: AuthService,
    public BetweenPagesService: BetweenPagesService,
    public loadingService: LoadingService
  ) {

    this.authorization = this.authService.getAuthorization();
  }

  ngOnInit(): void {

    OnAppModuleInit.subscribe(mod => {
      this.appModule = this.appModules[mod];
    });

    onHeaderLoading.subscribe(isLoading => {
      this.isLoading = isLoading;
    })

  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  home() {
    this.router.navigate(['/home']);
  }

  modalShortcutMenu() {
    const dialogRef = this.dialog.open(modalShortcutMenu);
  }

  projectInformationDialog() {
    const dialogRef = this.dialog.open(projectInformationDialog);
  }

  shareProject() {
    const dialogRef = this.dialog.open(shareProject, {height: '42vh', maxHeight: '44vh'});
  }
}

@Component({
  selector: 'shortcut-menu',
  templateUrl: 'shortcut-menu.html',
})
export class modalShortcutMenu {}

@Component({
  selector: 'info-menu',
  templateUrl: 'info-menu.html',
})

export class projectInformationDialog {
  version: string = "";

  constructor(
    private utilsService: UtilsService,
  ){}

  async ngOnInit() {
    this.version = this.utilsService.getAppVersion();
  }
}

@Component({
  selector: 'share-menu',
  templateUrl: 'share-menu.html',
})

export class shareProject {}
